/**
 * @group Constants
 *
 * @summary
 * <blockquote>Jitsi/JaaS configuration constants for JWT claims and room naming.</blockquote>
 *
 * @example
 * ```typescript
 * import { JITSI_CONSTANTS } from '@shared/telehealth/jitsi';
 *
 * const aud = JITSI_CONSTANTS.JWT_AUDIENCE;
 * ```
 */
export const JITSI_CONSTANTS = {
  /** Default JaaS domain */
  DEFAULT_DOMAIN: '8x8.vc',
  /** JWT audience claim (JaaS requirement) */
  JWT_AUDIENCE: 'jitsi' as const,
  /** JWT issuer claim (JaaS requirement) */
  JWT_ISSUER: 'chat' as const,
  /** JWT signing algorithm */
  JWT_ALGORITHM: 'RS256' as const,
  /** Telehealth provider name for Jitsi */
  PROVIDER_NAME: 'jitsi' as const,
  /** JWT type header */
  JWT_TYPE: 'JWT' as const,
  /** Regex to strip Prosody tenant prefix [vpaas-magic-cookie-xxx] from room names */
  TENANT_PREFIX_REGEX: /^\[vpaas-magic-cookie-[^\]]+\]/,
} as const;
